import styled from 'styled-components';

export const CalendyContainer = styled.div`
  height: 500px;
  width: 100%;
  position: relative;
  margin-bottom: 20px;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  & > iframe {
    height: 0;
    max-height: 100%;
    max-width: 100%;
    min-height: 100%;
    min-width: 100%;
    width: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Training/elements.js